import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ContactsService } from './contacts.service';
import { SharedDataService } from './shared-data/shared-data.service';
import { PS_ExtUsersList_Result, PS_ExtUsersList_V2_Result,PS_ExtUsersList_V3_Result, SimpleReponseResult, Contact, Supplier, ExtUser,PS_Search_Suppliers_Result } from '../all-models';

@Injectable({
  providedIn: 'root'
})
export class ExtUsersService {
extUsersUrl: string 
  constructor(public sharedDataSvc:SharedDataService, private http: HttpClient,private contactsSvc: ContactsService) { 
    this.extUsersUrl = this.sharedDataSvc.apiBaseUrl + 'ExtUsers';
  }
  
  getExtUsers(): Observable<ExtUser[]> {
    return this.http.get<ExtUser[]>(this.extUsersUrl);
  }
  getExtUsersList(): Observable<PS_ExtUsersList_Result[]> {
    return this.http.get<PS_ExtUsersList_Result[]>(`${this.extUsersUrl}/List`);
  }
  getExtUsersListV2(): Observable<PS_ExtUsersList_V2_Result[]> {
    return this.http.get<PS_ExtUsersList_V2_Result[]>(`${this.extUsersUrl}/ListV2`);
  }

  getExtUsersListV3(): Observable<PS_ExtUsersList_V3_Result[]> {
    return this.http.get<PS_ExtUsersList_V3_Result[]>(`${this.extUsersUrl}/ListV3/${this.sharedDataSvc.lngCod}`);
  }
  /*
  CheckLogin(loginParam: LoginParameters) : Observable<PS_CheckLogin_Result> {
    return this.http.post<PS_CheckLogin_Result>(this.extUsersUrl + '/CheckLogin', loginParam);
  }*/

  getExtUser(userId: number): Observable<ExtUser> {
    return this.http.get<ExtUser>(`${this.extUsersUrl}/${userId}`);
  }

  getExtUserContact(user:ExtUser): Observable<Contact> {
    return this.contactsSvc.getContact(user.ContactId);
  }

  getSuppliers (userId:number): Observable<Supplier[]>{
    if (userId>0){
      return this.http.get<Supplier[]>(`${this.extUsersUrl}/${userId}/getSuppliers`);
    } else {
      return of([]);
    }
  }

  getLoggedUserSuppliers (): Observable<PS_Search_Suppliers_Result[]>{
   return this.http.get<PS_Search_Suppliers_Result[]>(`${this.extUsersUrl}/loggedUser/Suppliers`);
  }


  getLoggedUser (): Observable<ExtUser>{
    return this.http.get<ExtUser>(`${this.extUsersUrl}/loggedUser`);
   }
 
  PostExtUserByMail(email: string): Observable<ExtUser> {
    let searchParam : ExtUser = new ExtUser();
    searchParam.Email = email;
    return this.http.post<ExtUser>(`${this.extUsersUrl}/ExtUserByMail`, searchParam);
  }
  postExtUser(user: ExtUser) : Observable<ExtUser> {
    return this.http.post<ExtUser>(this.extUsersUrl,user);
  }

  putExtUser(user: ExtUser) : void {
    this.http.put<ExtUser>(this.extUsersUrl,user);
  }

  resetPassword(user: ExtUser) :  Observable<SimpleReponseResult> {
    return this.http.post<SimpleReponseResult>(`${this.extUsersUrl}/ResetPassword`, user);
  }

  changeStatus(user: ExtUser,newStatutId : number) :  Observable<ExtUser> {
    user.StatusId = newStatutId;
    return this.http.post<ExtUser>(`${this.extUsersUrl}/ChangeStatus`, user);
  }
  initPassword(supplier: Supplier) :  Observable<ExtUser> {
    return this.http.post<ExtUser>(`${this.extUsersUrl}/InitPassword`,  supplier);
  }

  delExtUser(user: ExtUser) : void {
    this.http.delete<ExtUser>(`${this.extUsersUrl}/${user.Id}`);
  }

  search (searchParams:ExtUser): Observable<ExtUser[]>{
    return this.http.post<ExtUser[]>(`${this.extUsersUrl}/Search`, searchParams);
  }

 mailNotifyNewSupplier(extUserId:number, supplierId:number):Observable<SimpleReponseResult>{
   return this.http.post<SimpleReponseResult>(`${this.extUsersUrl}/${extUserId}/Mail/NotifyNewSupplier/${supplierId}`,null);
 }
 createExtUserFromContact (contactId:number,supplier:Supplier): Observable<ExtUser> {
   return this.http.post<ExtUser>(`${this.extUsersUrl}/Create/FromContact/${contactId}`, supplier);
 }
 
 public isLocked(extUserId:number):Observable<boolean>{
  return this.http.get<boolean>(`${this.extUsersUrl}/${extUserId}/IsLocked`)
 }

}
